var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pxlt-video",class:{ 'video-overlay': !_vm.playStarted }},[_c('video',{ref:"pxltVideo",attrs:{"src":_vm.source,"alt":"Pixellot Video"}}),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.playStarted),expression:"!playStarted"}],staticClass:"btn-play",on:{"click":_vm.playVideo}})])
}
var staticRenderFns = []

export { render, staticRenderFns }